module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "padding": "0 4px"
    },
    on: {
      "click": function($event) {
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_vm._v("\n    " + _vm._s(this.icon) + "\n  ")]), _vm._v(" "), (_vm.dialog) ? _c('div', {
    staticClass: "icon-dialog"
  }, [_vm._l((_vm.icons), function(dialogIcon, i) {
    return _c('a', {
      key: ("icon-" + i),
      staticClass: "icon-dialog-icon",
      class: {
        'icon-active': _vm.icon == dialogIcon
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.select(dialogIcon)
        }
      }
    }, [_vm._v(_vm._s(dialogIcon))])
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icon),
      expression: "icon"
    }],
    staticClass: "icon-input",
    domProps: {
      "value": (_vm.icon)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.icon = $event.target.value
      }, _vm.finish]
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a8e220c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IdeaIcon.vue
// module id = 159
// module chunks = 1